module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAECAYAAAB7oZQmAAAAAXNSR0IArs4c6QAAABlJREFUGBlj7D0k/5+BxoCJxuaDjR8+lgAA1asCdUTlWzEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/aqua_harps4_com/images/icon_line_lime@2x.png
// module id = 304
// module chunks = 0